module.exports = __webpack_public_path__ + "static/media/bg-college.a2e61f24.jpg";